import React, { useEffect, useState } from "react";
import "./Namuna9.css";

const Namuna9 = () => {
  const [records, setRecords] = useState([]);

  useEffect(() => {
    const saved = localStorage.getItem("namuna8ModernRecords");
    setRecords(saved ? JSON.parse(saved) : []);
  }, []);

  const printAll = () => {
    window.print();
  };

  return (
    <div className="namuna9-page">
      <div className="no-print top-actions">
        <button onClick={printAll}>🖨️ नमुना ९ प्रिंट</button>
      </div>

      <div className="namuna9-header">
        <h2>नमुना नं. ९</h2>
        <h3>कर मागणी व वसुली नोंदवही</h3>
        <p>ग्रामपंचायत : भलेवाडी | ता. कारंजा (घा) | जि. वर्धा</p>
      </div>

      <table className="namuna9-table">
        <thead>
          <tr>
            <th>अ.क्र.</th>
            <th>मालमत्ता क्र.</th>
            <th>मालकाचे नाव</th>
            <th>भोगवटादार</th>
            <th>घरपट्टी</th>
            <th>दिवाबत्ती</th>
            <th>आरोग्य कर</th>
            <th>पाणीपट्टी</th>
            <th>एकूण मागणी</th>
            <th>वसूल रक्कम</th>
            <th>बाकी</th>
            <th>शेरा</th>
          </tr>
        </thead>

        <tbody>
          {records.length === 0 ? (
            <tr>
              <td colSpan="12">नमुना ८ मधील कोणताही data उपलब्ध नाही</td>
            </tr>
          ) : (
            records.map((r, index) => {
              const total =
                Number(r.houseTax || 0) +
                Number(r.lightTax || 0) +
                Number(r.healthTax || 0) +
                Number(r.waterTax || 0);

              const paid = Number(r.paidAmount || 0);
              const balance = total - paid;

              return (
                <tr key={r.id}>
                  <td>{index + 1}</td>
                  <td>{r.propertyNo}</td>
                  <td>{r.ownerName}</td>
                  <td>{r.occupierName}</td>
                  <td>₹ {r.houseTax || 0}</td>
                  <td>₹ {r.lightTax || 0}</td>
                  <td>₹ {r.healthTax || 0}</td>
                  <td>₹ {r.waterTax || 0}</td>
                  <td>₹ {total}</td>
                  <td>₹ {paid}</td>
                  <td>₹ {balance}</td>
                  <td>{r.shera}</td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Namuna9;